import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { Card } from 'packages/eid-ui'
import { Box } from '@mui/material'
import { EidAutocomplete } from 'packages/eid-controls'
import { Icon } from 'packages/eid-icons'
import { isNilOrEmpty } from 'packages/core'

const GroupOptionComponent = EidAutocomplete.getOptionComponent({
    type: 'label',
    labelProp: 'name',
})


const getOptionLabel = (option) => option.name

const OrgRoleOrgZoneFilter = ({ config }) => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()
    const queryParams = {
        trackingID: config?.trackingID,
        rtaLandscapeIdList: Array.isArray(state?.landscapes) && state?.landscapes?.map(landscape => landscape.id) || []
    }

    const filter = (
        <Box padding="18px">
            <EidAutocomplete.New
                placeholder={t('SelectOrgRoleOrgZone')}
                url={config?.url}
                queryParams={queryParams}
                getOptionLabel={getOptionLabel}
                dedupingInterval={60000}
                value={state.orgRoleOrgZoneSelection ? state.orgRoleOrgZoneSelection : null}
                optionComponent={GroupOptionComponent}
                supportsServerSideSearch={false}
                minCharactersReqForSearch={0}
                clearIcon={
                    !isNilOrEmpty(state.orgRoleOrgZoneSelection) && (
                        <Icon
                            name="Close"
                            color="#959598"
                            onClick={() =>
                                dispatch({
                                    type: 'SET_PROP',
                                    payload: {
                                        key: 'orgRoleOrgZoneSelection',
                                        value: null,
                                    },
                                })
                            }
                        />
                    )
                }
                onChange={(_, value) => {
                    dispatch({
                        type: 'SET_PROP',
                        payload: {
                            key: 'orgRoleOrgZoneSelection',
                            value: value,
                        },
                    })
                }}
            />
        </Box>
    )

    return (
        <Card
            cardTitle={t('OrgRoleOrgZone')}
            color="#fff"
            collapsible
            expanded={Boolean(state.orgRoleOrgZoneSelection)}
        >
            {filter}
        </Card>
    )
}

export default OrgRoleOrgZoneFilter
